<template>
  <div style="margin-top: 10px">
    <div class="row">
      <div class="col-md-12">
        <label>Tarjeta</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-8 col-xs-6">
        <base-input v-model="model.Aux1" @blur="change" :maxlength="16"></base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <money-with-indicator v-model="model.Importe" v-on:blur="change" v-on:validatedOK="onSaldoOK"/>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';

export default {
  components: {
    "money-with-indicator": MoneyWithIndicator
  },
  props: {
    model: {
      Aux1: "",
      Aux2: "",
      Aux3: "",
      Aux4: "",
      Importe: "",
      Validate: false,
      Errors: []
    }
  },
  data() {
    return {};
  },
  methods: {
    change(element) {
      this.validate();
      this.$emit("input", this.model);
    },
    validate() {
      let context = this;
      context.model.Errors = [];

      if (context.model.Aux1.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar el número de tarjeta");
      } else if (context.model.Aux1.length != 16) {
        context.model.Validate = false;
        context.model.Errors.push("La tarjeta debe tener 16 digitos");
      } else if (context.model.Importe <= 0) {
        context.model.Validate = false;
        context.model.Errors.push("El importe no puede ser menor que 0");
      } else if (!context.validateDigits(context.model.Aux1,context)) {
        context.model.Validate = false;
        context.model.Errors.push("La tarjeta ingresada no es valida");
      } else {
        context.model.Validate = true;
      }
    },
    validateDigits(val,context) {
      var tarjeta = val;
      var dv = parseInt(tarjeta.substring(tarjeta.length - 1));
      var sum = 0;
      var alternate = true;
      var i = 0;
      // -- Calculamos el dígito verificador (2º Paso)
      // --------------------------------------------------------------------------------------
      for (i = tarjeta.length - 1; i > 0; i--) {
        var n = parseInt(tarjeta.substring(i - 1, i));

        if (alternate) {
          alternate = false;

          n = n * 2;

          if (n > 9) {
            var nx = n.toString();
            n = parseInt(nx.substring(0, 1)) + parseInt(nx.substring(1));
          }
        } else {
          alternate = true;
        }

        sum = sum + n;
      }

      var d = sum / 10;

      var s = context.toAtLeastNDecimalPlaces(d, 1);

      var di = 10 - parseInt(s.substring(s.length - 1));

      if (di == 10) {
        di = 0;
      }
      // --------------------------------------------------------------------------------------

      // -- Comparamos los dígitos (3º Paso) si son iguales, es una tarjeta válida
      return di == dv;
    },
    toAtLeastNDecimalPlaces(num, n) {
      var normal_conv = num.toString();
      var fixed_conv = num.toFixed(n);
      return fixed_conv.length > normal_conv.length ? fixed_conv : normal_conv;
    },
    onSaldoOK(val) {
      this.$emit("saldoOK", val);
    }
  }
};
</script>